
// Partners

(function () {

	var el = document.querySelector( '.slider_partners .slider__items' )

	if ( !el ) return

	if ( !window.tns ) return console.error( "Sorry, Partners slider not working without Tiny slider!" );

	var slider = tns({
		container: el,
		items: 1,
		slideBy: 1,
		mouseDrag: false,
		controls: true,
		controlsContainer: '.slider_partners .slider__arrows',
		nextButton: '.slider_partners .slider__arrow_next',
		prevButton: '.slider_partners .slider__arrow_prev',
		nav: false,
		//navPosition: 'bottom',
		responsive: {
			// 480: {
			// 	items: 2,
			// 	slideBy: 2
			// },
			768: {
				items: 3,
				slideBy: 3
			},
			990: {
				items: 4,
				slideBy: 4
			},
			1200: {
				items: 5,
				slideBy: 5
			}
		}
	});

})();
